import * as React from 'react'
import MUICircularProgress from '@mui/material/CircularProgress'

const CircularProgress = (props) => <MUICircularProgress data-testid='circular-progress' {...props} />

export default CircularProgress
